/* Lush QC — scripts du thème (sans dépendance) */
(function () {
  'use strict';

  /* Menu mobile ------------------------------------------------------------ */
  document.querySelectorAll('[data-burger]').forEach(function (btn) {
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Galerie produit -------------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        slides.forEach(function (slide, i) { slide.hidden = i !== index; });
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      });
    });
  });

  /* Offres, type d'achat, barre collante ----------------------------------- */
  document.querySelectorAll('.pdp').forEach(function (section) {
    var offers = section.querySelector('[data-offers]');
    var variantInput = section.querySelector('[data-variant-input]');
    var planInput = section.querySelector('[data-plan-input]');
    var atc = section.querySelector('[data-atc]');
    var sticky = section.querySelector('[data-sticky]');

    function setText(selector, value) {
      section.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
    }
    function toggle(selector, show) {
      section.querySelectorAll(selector).forEach(function (el) { el.hidden = !show; });
    }

    function applyOffer(input) {
      var price = input.getAttribute('data-offer-price');
      var compare = input.getAttribute('data-offer-compare');
      var available = input.getAttribute('data-offer-available') === 'true';

      if (variantInput) variantInput.value = input.value;
      setText('[data-atc-price]', price);
      setText('[data-atc-compare]', compare);
      toggle('[data-atc-compare]', !!compare);
      if (atc) atc.disabled = !available;

      offers.querySelectorAll('[data-offer]').forEach(function (card) {
        card.classList.toggle('is-selected', card.querySelector('input') === input);
      });

      // Garde la variante choisie dans l'URL (partage / rechargement)
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (offers) {
      offers.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[type="radio"]')) applyOffer(event.target);
      });
    }

    // Achat unique / abonnement
    var purchaseInputs = section.querySelectorAll('[data-purchase]');
    purchaseInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var subscribe = input.value === 'subscribe' && input.checked;
        if (planInput) {
          planInput.disabled = !subscribe;
          if (subscribe) planInput.value = input.getAttribute('data-plan-id');
        }
        section.querySelectorAll('[data-purchase-opt]').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.querySelector('input').checked);
        });
      });
    });

    // Barre collante : visible quand le bouton principal est passé au-dessus de l'écran
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      });
      io.observe(atc);
    }
  });

  /* Carrousels ------------------------------------------------------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-track]');
    var prev = carousel.querySelector('[data-prev]');
    var next = carousel.querySelector('[data-next]');
    if (!track) return;
    function step() {
      var first = track.children[0];
      return first ? first.getBoundingClientRect().width + 20 : track.clientWidth;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Apparition au défilement ------------------------------------------------ */
  var reveals = document.querySelectorAll('.reveal');
  var inEditor = window.Shopify && window.Shopify.designMode;
  if (!('IntersectionObserver' in window) || inEditor) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function (el) { observer.observe(el); });
  }
})();
